import React from 'react'
import {
    Section,
    ContentWrapper,
    Container
} from './privacy.style'

const Privacy = () => {
    return (
        <Section className='privacy-section'>
            <ContentWrapper>
                <Container>
                    <h1>Privacy Policy for Zetit</h1>
                    <p><strong>Effective Date: February 26, 2025</strong></p>
                    <p>
                        Welcome to Zetit. Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services. Please read this policy carefully. If you do not agree with the terms of this privacy policy, please do not access the site.
                    </p>

                    <h2>1. Information We Collect</h2>
                    <p>We may collect information about you in various ways, including:</p>
                    <ul>
                        <li><strong>Personal Data:</strong> Personally identifiable information, such as your name, shipping address, email address, phone number, and demographic information (age, gender, hometown, etc.) that you voluntarily give to us when you register or participate in activities related to the site.</li>
                        <li><strong>Derivative Data:</strong> Information our servers automatically collect when you access the site, such as your IP address, browser type, operating system, access times, and the pages you viewed directly before and after accessing the site.</li>
                        <li><strong>Financial Data:</strong> Financial information, such as credit card numbers and billing details, required for purchases, refunds, or other transactions.</li>
                        <li><strong>Third-Party Data:</strong> Information from third parties, such as social media accounts if you choose to link your account with third-party platforms.</li>
                    </ul>

                    <h2>2. How We Use Your Information</h2>
                    <p>We use the collected information to:</p>
                    <ul>
                        <li>Create and manage your account.</li>
                        <li>Process your transactions.</li>
                        <li>Deliver the requested products and services.</li>
                        <li>Improve the website’s performance and user experience.</li>
                        <li>Send promotional materials and updates (with your consent).</li>
                        <li>Detect and prevent fraudulent transactions.</li>
                    </ul>

                    <h2>3. Sharing Your Information</h2>
                    <p>We may share your information with:</p>
                    <ul>
                        <li>Service providers assisting us with payment processing, hosting, and analytics.</li>
                        <li>Third-party marketing partners (only with your explicit consent).</li>
                        <li>Law enforcement, if required by applicable law.</li>
                    </ul>

                    <h2>4. Data Security</h2>
                    <p>
                        We use appropriate technical and organizational measures to protect your personal information. However, no method of transmission over the Internet is 100% secure. Therefore, we cannot guarantee absolute security.
                    </p>

                    <h2>5. Your Privacy Rights</h2>
                    <p>
                        Depending on your location, you may have rights under applicable privacy laws, including the right to access, correct, delete, or restrict how we process your data. To exercise these rights, contact us using the details provided below.
                    </p>

                    <h2>6. Cookies and Tracking</h2>
                    <p>We use cookies to improve your experience, analyze site traffic, and personalize content. You can control cookies through your browser settings.</p>

                    <h2>7. Children's Privacy</h2>
                    <p>Our services are not directed to children under the age of 13, and we do not knowingly collect personal information from children.</p>

                    <h2>8. Changes to This Privacy Policy</h2>
                    <p>We may update this Privacy Policy from time to time. Changes will be posted on this page with the updated date.</p>

                    <h2>9. Contact Us</h2>
                    <p>
                        If you have questions or comments about this policy, contact us at:
                    </p>
                    <p>
                        Zetit Customer Support <br />
                        Email: support@zetit.com <br />
                        Address: Zetit Inc, 123 Main Street, Kochi, Kerala, India
                    </p>

                    <div>
                        <h3>Additional Disclosures for Certain Regions</h3>
                        <p>
                            If you are a resident of the European Economic Area (EEA), the United Kingdom (UK), California (CCPA), or other jurisdictions with specific privacy rights, please refer to the additional regional-specific privacy disclosures provided in our complete Privacy Statement.
                        </p>
                    </div>
                </Container>
            </ContentWrapper>
        </Section>
    )
}

export default Privacy
